import PortalButton from "src/components/common/PortalButton/PortalButton";

export interface PaginationBarProps {
  totalCount: number;
  setQuery: (query: Record<string, unknown>) => void;
  page: number;
  pageSize: number;
}

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const PaginationBar: React.FC<PaginationBarProps> = ({
  totalCount,
  setQuery,
  page,
  pageSize,
}) => {
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const handlePrev = () => setQuery({ page: Math.max(1, page - 1) });
  const handleNext = () => setQuery({ page: Math.min(totalPages, page + 1) });
  const handlePageSizeChange = (size: number) => {
    setQuery({ page: 1, page_size: size });
  };

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
      {renderPageSizeDropdown()}
      <div className="text-muted text-center flex-grow-1 mb-2 mb-md-0">
        {from} - {to} of {totalCount}
      </div>
      {renderPaginationControls()}
    </div>
  );

  function renderPaginationControls() {
    return (
      <div className="d-flex mb-2 mb-md-0">
        <div className="mr-2">
          <PortalButton
            callback={handlePrev}
            icon={<i className="material-icons">chevron_left</i>}
            disabled={page <= 1}
            variant="primary"
          />
        </div>
        <div>
          <PortalButton
            callback={handleNext}
            icon={<i className="material-icons">chevron_right</i>}
            disabled={page >= totalPages}
            variant="primary"
          />
        </div>
      </div>
    );
  }

  function renderPageSizeDropdown() {
    return (
      <div className="mb-2 mb-md-0">
        <div className="form-inline mb-0">
          <label
            htmlFor="page-size-select"
            className="mb-0 mr-2 font-weight-semibold"
          >
            Rows per page:
          </label>
          <select
            id="page-size-select"
            className="form-control form-control-sm"
            value={pageSize}
            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
          >
            {PAGE_SIZE_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
};
